(function () {
  'use strict';

  function money(cents) {
    return '¥' + Math.round((Number(cents) || 0) / 100).toLocaleString('ja-JP');
  }

  function parseJSON(node) {
    if (!node) return [];
    try { return JSON.parse(node.textContent.trim()); } catch (error) { return []; }
  }

  function initProductPage(page) {
    if (!page || page.dataset.relxProductReady === 'true') return;
    page.dataset.relxProductReady = 'true';

    var root = page.querySelector('[data-callBackVariant]');
    var form = root && root.querySelector('form[data-type="add-to-cart-form"]');
    if (!root || !form) return;

    var select = form.querySelector('select[name="id"]');
    var variants = parseJSON(root.querySelector('.pr_variants_json'));
    var summary = form.querySelector('[data-relx-selection-value]');
    var originalButton = form.querySelector('[data-atc-form]');
    var originalButtonText = originalButton && originalButton.querySelector('.t4s-btn-atc_text');
    var bar = document.querySelector('[data-relx-mobile-buybar][data-product-form-id="' + form.id + '"]');
    var barSelection = bar && bar.querySelector('[data-relx-mobile-selection]');
    var barPrice = bar && bar.querySelector('[data-relx-mobile-price]');
    var barButton = bar && bar.querySelector('[data-relx-mobile-submit]');
    var barButtonText = barButton && barButton.querySelector('[data-relx-mobile-submit-text]');

    function variant() {
      if (!select) return variants[0] || null;
      return variants.find(function (item) { return String(item.id) === String(select.value); }) || null;
    }

    function selectedText(current) {
      if (current && Array.isArray(current.options)) {
        return current.options.filter(function (value) { return value && value !== '適用外'; }).join(' / ');
      }
      if (select && select.options[select.selectedIndex]) return select.options[select.selectedIndex].textContent.trim();
      return '仕様を選択してください';
    }

    function update() {
      var current = variant();
      var text = selectedText(current);
      if (summary) summary.textContent = text;
      if (barSelection) barSelection.textContent = text;
      if (barPrice && current) barPrice.textContent = money(current.price);

      var available = current ? current.available !== false : !(originalButton && originalButton.disabled);
      if (barButton) {
        barButton.disabled = !available;
        barButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
      if (barButtonText) {
        barButtonText.textContent = available ? ((originalButtonText && originalButtonText.textContent.trim()) || 'カートに追加') : '売り切れ';
      }
    }

    if (select) select.addEventListener('change', function () { window.setTimeout(update, 0); });
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-swatch-item]')) window.setTimeout(update, 80);
    });
    document.addEventListener('variant:change', update);

    if (barButton && originalButton) {
      barButton.addEventListener('click', function () {
        if (barButton.disabled) return;
        var rect = form.getBoundingClientRect();
        var formVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (!formVisible && !variant()) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        originalButton.click();
      });
    }

    if (bar && originalButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0.05 });
      observer.observe(originalButton);
    }

    update();
  }

  function boot() {
    document.querySelectorAll('[data-relx-product-page]').forEach(initProductPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
